import { render, staticRenderFns } from "./headline.vue?vue&type=template&id=682355be&scoped=true"
import script from "./headline.vue?vue&type=script&lang=js"
export * from "./headline.vue?vue&type=script&lang=js"
import style0 from "./headline.vue?vue&type=style&index=0&id=682355be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682355be",
  null
  
)

export default component.exports